import {format} from 'date-fns';
import {ptBR} from 'date-fns/locale';

export function stringfyDate(date: Date | null, formatDate: string = 'P') {
	if (!date) {
		return '';
	}
	return format(date, formatDate, {locale: ptBR});
}
